import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import {Controller, useForm} from "react-hook-form";
import {useNavigate, useParams} from 'react-router-dom';
import CreatableSelect from "react-select/creatable";

import classes from './form.module.scss';
import errorMessage from "../../../../const/Tost";
import {contractService} from "../../../../api/contractService";
import {createClinic} from "../AddClinic/ClinicData";
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import ArchiveIcon from '@mui/icons-material/Archive';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {HospitalService} from "../../../../api/HospitalService";
import {DirectionService} from "../../../../api/directionService";

const EditClinic = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const values = createClinic;

    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
        control,
    } = useForm();

    const [departments, setDepartments] = useState([]);
    const [departmentsUniqName, setDepartmentsUniqName] = useState([]);
    const [updatedDepartments, setUpdatedDepartments] = useState([]);

    const onSubmit = async(data) => {
        try{
            const formattedDepartments = departments.map(dep => ({id: dep.id, name: dep.name}));

            await DirectionService.editClinic({
                ...data,
                id: data.id || id,
                departments: formattedDepartments,
                registrationType: "COMPLETED"
            });

            navigate('/ClinicList');
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    };

    useEffect(() => {
        contractService.getCompleteHospital(id).then(res => {
            if (res?.data){
                const result = {
                    ...res.data,
                    departments: res.data.departments?.map(item => item.name),
                };
                reset(result);
                setDepartments(res.data.departments || []);
                setDepartmentsUniqName(res.data.departments || []);
            }
        });
    }, [id, reset]);

    const handleDepartmentChange = (index, value) => {
        const updated = [...departments];
        const original = updated[index];
        updated[index] = {...original, name: value};
        setDepartments(updated);

        if (original.id){
            const already = updatedDepartments.find(dep => dep.id === original.id);
            if (!already){
                setUpdatedDepartments(prev => [...prev, {id: original.id, name: value}]);
            } else {
                setUpdatedDepartments(prev =>
                    prev.map(dep =>
                        dep.id === original.id ? {...dep, name: value} : dep
                    )
                );
            }
        }
    };

    const handleCreateDepartment = async (hospitalId, name) => {
        if (name.length === 0) {
            errorMessage('', 'Введіть назву клініки');
            return;
        }

        try {
            const response = await HospitalService.createDepartment(hospitalId, name);
            if (response?.data) {
                setDepartmentsUniqName(prev => [...prev, response.data]);
                setDepartments(prev =>
                    prev.map(dep =>
                        dep.name === response.data.name
                            ? { ...dep, id: response.data.id }
                            : dep
                    )
                );
            }
        } catch (error) {
            errorMessage(error, error?.response?.data?.message);
        }
    };

    const handleUpdateDepartment = async (departmentId, hospitalId, name) => {
        if (name.length === 0) {
            errorMessage('', 'Введіть назву клініки');
            return;
        }

        try {
            const response = await HospitalService.updateDepartment(departmentId, hospitalId, name);
            if (response?.data) {
                setDepartments(prev =>
                    prev.map(dep =>
                        dep.id === departmentId ? {...dep, name: response.data.name} : dep
                    )
                );
                setDepartmentsUniqName(prev =>
                    prev.map(dep =>
                        dep.id === departmentId ? {...dep, name: response.data.name} : dep
                    )
                );
            }
        } catch (error) {
            errorMessage(error, error?.response?.data?.message);
        }
    };

    const handleDeleteFromState = (index) => {
        setDepartments(prev => {
            const updated = [...prev];
            updated.splice(index, 1);
            return updated;
        });
    };


    const handleDeleteDepartment = async (hospitalId, departmentId) => {
        try {
            await HospitalService.deleteDepartment(hospitalId, departmentId);
            setDepartments(prev => prev.map(dep =>
                dep.id === departmentId ? {...dep, isDeleted: true} : dep
            ));
        } catch (error) {
            errorMessage(error, error?.response?.data?.message);
        }
    };

    const handleAddDepartment = () => {
        const newDep = {id: null, name: '', hospitalId: Number(id)};
        setDepartments(prev => [...prev, newDep]);
    };

    return (
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
            <div className={classes.form__wrapper}>
                <div className={classNames(classes.form__title)}>Редагування клініки</div>
            </div>

            {values.fields.map((el, index) => (
                <div className={classes[values.class]} key={index}>
                    <div
                        className={classNames(
                            el.name === 'cassetsAfter'
                                ? classes.form__input__cassets
                                : classes.form__label__container,
                            {[classes.register__container]: values.formType === 'singIn'}
                        )}
                    >
                        {el.options ? (
                            <>
                                <div style={{width: '30%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                                    <label>{el.legend}</label>
                                </div>
                                <div style={{width: '350px'}}>
                                    {!id || el.name !== 'departments' ? (
                                        <Controller
                                            control={control}
                                            name={el.name}
                                            render={({field: {onChange, value}}) => (
                                                <CreatableSelect
                                                    className={classNames(classes.react__select)}
                                                    isMulti
                                                    isDisabled={id && el.name === 'departments'}
                                                    options={(value || []).map(val => ({label: val, value: val}))}
                                                    value={(value || []).map(val => ({label: val, value: val}))}
                                                    onChange={(selectedOptions) => {
                                                        const newValues = selectedOptions.map(option => option.value);
                                                        onChange(newValues);
                                                    }}
                                                    placeholder="Введіть значення і натисніть Enter"
                                                    isClearable={false}
                                                    formatCreateLabel={(inputValue) => `${inputValue}`}
                                                />
                                            )}
                                        />
                                    ) : (
                                        <div className={classes.form__section}>
                                            {departments?.sort((a, b) => {
                                                const aHasId = a.id != null;
                                                const bHasId = b.id != null;

                                                const aDeleted = a.isDeleted === true;
                                                const bDeleted = b.isDeleted === true;

                                                if (aDeleted !== bDeleted) {
                                                    return aDeleted ? 1 : -1;
                                                }

                                                if (aHasId !== bHasId) {
                                                    return aHasId ? -1 : 1;
                                                }

                                                return 0;
                                            })?.map((dep, index) => (
                                                <div key={index} className={classNames(classes.department_edit)}>
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        value={dep.name}
                                                        style={{padding: '10px 10px'}}
                                                        disabled={dep.isDeleted}
                                                        onChange={(e) => handleDepartmentChange(index, e.target.value)}
                                                        placeholder="Назва відділення"
                                                    />

                                                    {dep.id && !dep.isDeleted &&
                                                        <IconButton color="success" onClick={() => handleUpdateDepartment(id, dep.id, dep.name)}
                                                                    disabled={
                                                                        !dep.name?.trim() ||
                                                                        departmentsUniqName.some(
                                                                            d =>
                                                                                d.id !== dep.id &&
                                                                                d.name.trim().toLowerCase() === dep.name.trim().toLowerCase()
                                                                        )
                                                                    }>
                                                            <SaveIcon/>
                                                        </IconButton>
                                                    }

                                                    {!dep.id &&
                                                        <IconButton color="success" onClick={() => handleCreateDepartment(id, dep.name)}>
                                                            <SaveIcon/>
                                                        </IconButton>
                                                    }
                                                    {!dep.id && !dep.isDeleted &&
                                                        <IconButton color="error" onClick={() => handleDeleteFromState(index)}>
                                                            <ArchiveIcon/>
                                                        </IconButton>
                                                    }
                                                    {dep.id && !dep.isDeleted &&
                                                        <IconButton color="error" onClick={() => handleDeleteDepartment(id, dep.id)}>
                                                            <ArchiveIcon/>
                                                        </IconButton>
                                                    }
                                                </div>
                                            ))}
                                            {!departments.some((dep, index) => (dep.id === null)) ?
                                                <div style={{display: "flex", justifyContent: "center"}}>
                                                    <IconButton color="primary" onClick={handleAddDepartment}>
                                                        <AddCircleOutlineIcon/>
                                                    </IconButton>
                                                </div>
                                                : <div style={{padding: "10px"}}>Збережіть або видаліть додавання клініки</div>}
                                        </div>
                                    )}
                                </div>
                            </>
                        ) : (
                            <>
                                {el.props.map((props, i) => (
                                    <div
                                        className={classNames(
                                            classes.form__label__container__box,
                                            {[classes.register__container]: values.formType === 'singIn'}
                                        )}
                                        key={'a' + i}
                                    >
                                        <div><label>{props.label}</label></div>
                                        <div>
                                            <div className={el.name === 'cassetsAfter' ? classes.form__input__cassets : {}}>
                                                <input
                                                    className={classNames(classes.form__input, {
                                                        [classes.errorInput]: errors[el.name]
                                                    })}
                                                    type={props.type}
                                                    min={props.min}
                                                    max={props.max}
                                                    disabled={props.show}
                                                    placeholder={props.placeholder}
                                                    pattern={props.pattern}
                                                    {...register(el.name, {required: el.required})}
                                                />
                                            </div>
                                            {errors[el.name] && (
                                                <p className={classNames('DefaultForm-input-hint', classes.errorHint)}>
                                                    Це поле є обов'язковим
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                </div>
            ))}

            <button className={classes.form__button} type="submit">Зберегти</button>
        </form>
    );
};

export default EditClinic;
